module.exports = __webpack_public_path__ + "static/media/fondo_otros.8fd6b5f3.jpg";